<div [ngClass]="{ 'gallery-image': isGallery, image: !isGallery }" (click)="toggleFullScreen()">
  @if (props.compareValue) {
    <img class="me-2" src="data:image/png;base64,{{ props.compareValue }}" />
  }
  @if (isUrl) {
    <img [src]="field.defaultValue" />
  } @else {
    <img *ngIf="!isUrl" src="data:image/png;base64,{{ field.defaultValue }}" />
  }
</div>
